// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"93d419b125df742fbcb7","641":"8e04e5a9cf55ba48fce7","691":"4f80d718859b54b012d0","698":"90f773084df5c4bc11ce","883":"c34a15279738590fce8c"}[chunkId] + ".js";
};